import React, { useEffect, useMemo, useState } from "react";
import AppModal from "../AppModal";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const ACTION_TYPES = [
	{ value: "Setor", label: "Setor" },
	{ value: "Atendente", label: "Atendente" },
	{ value: "Conexão", label: "Conexão" },
	{ value: "Status", label: "Status" },
	{ value: "+Etiqueta", label: "Adicionar tag" },
	{ value: "-Etiqueta", label: "Remover tag" },
];

const STATUS_OPTIONS = ["Aberto", "Fechado", "Aguardando"];

function FieldLabel({ children }) {
	return (
		<label className="mb-2 block text-sm font-medium text-default-800 dark:text-default-100">
			{children}
		</label>
	);
}

export const ActionModal = ({
	open,
	handleClose,
	selectedChatbot,
	setSelectedChatbot,
	data: { queues = [], users = [], connections = [], tags = [] },
	nodeId,
	optionId,
}) => {
	const [actionType, setActionType] = useState("Setor");
	const [actionShould, setActionShould] = useState("");

	useEffect(() => {
		if (!open) return;
		setActionType("Setor");
		setActionShould("");
	}, [open]);

	const options = useMemo(() => {
		if (actionType === "Setor") {
			return queues.map(queue => ({ value: queue.id, label: queue.name }));
		}

		if (actionType === "Atendente") {
			return users.map(user => ({ value: user.id, label: user.name }));
		}

		if (actionType === "Status") {
			return STATUS_OPTIONS.map(status => ({ value: status, label: status }));
		}

		if (actionType === "+Etiqueta" || actionType === "-Etiqueta") {
			return tags.map(tag => ({ value: tag.id, label: tag.name }));
		}

		return connections.map(connection => ({
			value: connection.id,
			label: connection.name,
		}));
	}, [actionType, connections, queues, tags, users]);

	const handleSave = async () => {
		if (!actionShould) return;

		try {
			const { data: newAction } = await api.post("/chatbot/action", {
				name: actionType,
				should: actionShould,
				optionId,
			});

			setSelectedChatbot(prevState => ({
				...prevState,
				nodes: (prevState.nodes || []).map(node => {
					if (Number(node.id) !== Number(nodeId)) {
						return node;
					}

					return {
						...node,
						options: (node.options || []).map(option => {
							if (Number(option.id) !== Number(optionId)) {
								return option;
							}

							return {
								...option,
								action: option.action ? [...option.action, newAction] : [newAction],
							};
						}),
					};
				}),
			}));

			handleClose();
		} catch (err) {
			toastError(err);
		}
	};

	return (
		<AppModal
			open={open}
			onClose={handleClose}
			title="Adicionar ação"
			subtitle="Escolha o tipo da ação automática e o destino que será aplicado."
			maxWidth={520}
			footer={
				<>
					<button
						type="button"
						className="btn btn-sub-gray"
						onClick={handleClose}
					>
						Cancelar
					</button>
					<button
						type="button"
						className="btn bg-primary text-white"
						onClick={handleSave}
						disabled={!actionShould}
					>
						Adicionar
					</button>
				</>
			}
		>
			<div className="space-y-4">
				<div>
					<FieldLabel>Tipo da ação</FieldLabel>
					<select
						className="form-select w-full"
						value={actionType}
						onChange={event => {
							setActionType(event.target.value);
							setActionShould("");
						}}
					>
						{ACTION_TYPES.map(action => (
							<option key={action.value} value={action.value}>
								{action.label}
							</option>
						))}
					</select>
				</div>

				<div>
					<FieldLabel>Destino</FieldLabel>
					<select
						className="form-select w-full"
						value={actionShould}
						onChange={event => setActionShould(event.target.value)}
					>
						<option value="">Selecione...</option>
						{options.map(option => (
							<option key={`${actionType}-${option.value}`} value={option.value}>
								{option.label}
							</option>
						))}
					</select>
				</div>
			</div>
		</AppModal>
	);
};
